import { jsx as t, jsxs as m } from "react/jsx-runtime";
import { c as r } from "./clsx.OuTLNxxd.js";
import { c as u } from "./create-location-link.CWUHCgFz.js";
import { U as f } from "./unified-link.DNdCokeG.js";
const p = ({ className: n, distance: e }) => {
  if (Number.isNaN(e) || e === void 0)
    return null;
  const s = `${(Math.round(e * 10) / 10).toFixed(1)} miles`;
  return /* @__PURE__ */ t("span", { className: r("neu-text-body fw-bold", n), children: s });
}, D = ({
  distance: n,
  facilityTitle: e,
  facilityUrl: o,
  marketedWebsite: s,
  className: l = "d-flex align-items-center justify-content-between",
  titleClass: a,
  distanceClass: c = "d-none d-lg-inline"
}) => {
  const d = u({
    url: o ?? s ?? "",
    text: e
  }), i = r("neu-display-4 fw-bold", a);
  return /* @__PURE__ */ m("div", { className: l, children: [
    o || s ? /* @__PURE__ */ t(f, { field: d, className: i }) : /* @__PURE__ */ t("p", { className: i, children: e }),
    n && /* @__PURE__ */ t(p, { className: c, distance: n })
  ] });
};
export {
  p as D,
  D as L
};
